// // import React, { useEffect, useState } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { logout } from '../redux/slices/authSlice';
// // import {
// //     fetchDashboardRequest,
// //     updateProfileRequest,
// //     deleteProfileRequest,
// //     addEmployeeRequest,
// //     editEmployeeRequest,
// //     removeEmployeeRequest
// // } from '../redux/slices/userSlice';
// // import SEO from '../components/SEO';
// // import {
// //     Key, UserPlus, Trash2, Edit2, Users, ShieldCheck,
// //     LogOut, AlertTriangle, User, Settings, Download, Info
// // } from 'lucide-react';

// // const Dashboard = () => {
// //   const [activeTab, setActiveTab] = useState('vpn');
// //   const [newEmail, setNewEmail] = useState('');
// //   const [localProfile, setLocalProfile] = useState({});

// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();

// //   // Connect to Redux State
// //   const { token } = useSelector(state => state.auth);
// //   const { profile, license, status, loading } = useSelector(state => state.user);

// //   // 1. Fetch data on load via Redux
// //   useEffect(() => {
// //     if (!token) navigate('/login');
// //     else dispatch(fetchDashboardRequest());
// //   }, [token, navigate, dispatch]);

// //   // 2. Sync local form state when Redux profile updates
// //   useEffect(() => {
// //     if (profile) setLocalProfile(profile);
// //   }, [profile]);

// //   const handleLogout = () => { dispatch(logout()); navigate('/login'); };

// //   // --- Profile Logic ---
// //   const handleProfileUpdate = (e) => {
// //       e.preventDefault();
// //       dispatch(updateProfileRequest(localProfile));
// //   };

// //   const handleAccountDelete = () => {
// //       if(!window.confirm("Are you sure? This deletes your account and VPN access permanently.")) return;
// //       dispatch(deleteProfileRequest());
// //   };

// //   // --- Employee Logic ---
// //   const handleAddEmployee = (e) => {
// //     e.preventDefault();
// //     if (!newEmail) return;
// //     dispatch(addEmployeeRequest({ license_key: license.license_key, employee_email: newEmail }));
// //     setNewEmail('');
// //   };

// //   const handleEditEmployee = (oldEmail) => {
// //     const n = prompt(`Update email:`, oldEmail);
// //     if (!n || n === oldEmail) return;
// //     dispatch(editEmployeeRequest({ license_key: license.license_key, old_email: oldEmail, new_email: n }));
// //   };

// //   const handleRemoveEmployee = (email) => {
// //     if(!window.confirm(`Revoke access for ${email}?`)) return;
// //     dispatch(removeEmployeeRequest({ license_key: license.license_key, employee_email: email }));
// //   };

// //   const calcMonths = (s, e) => {
// //     const d1 = new Date(s), d2 = new Date(e);
// //     return Math.max(1, (d2.getFullYear() - d1.getFullYear()) * 12 - d1.getMonth() + d2.getMonth());
// //   };

// //   if (loading && !profile.name) return <div className="text-center p-10 text-white">Loading...</div>;

// //   return (
// //     <div className="max-w-6xl mx-auto p-6 text-white pb-20">
// //       <SEO title="User Dashboard" />

// //       <div className="flex justify-between items-center mb-8">
// //         <h1 className="text-3xl font-bold flex items-center gap-3">
// //             <ShieldCheck className="text-qrypt-primary w-8 h-8"/> Dashboard
// //         </h1>
// //         <button onClick={handleLogout} className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 px-4 py-2 rounded transition">
// //             <LogOut className="w-4 h-4"/> Logout
// //         </button>
// //       </div>

// //       {/* TABS */}
// //       <div className="flex gap-4 mb-8 border-b border-gray-800 pb-2">
// //           <button onClick={()=>setActiveTab('vpn')} className={`pb-2 px-2 font-bold transition flex items-center gap-2 ${activeTab==='vpn' ? 'text-qrypt-primary border-b-2 border-qrypt-primary' : 'text-gray-500 hover:text-white'}`}><Key className="w-4 h-4"/> VPN Access</button>
// //           <button onClick={()=>setActiveTab('profile')} className={`pb-2 px-2 font-bold transition flex items-center gap-2 ${activeTab==='profile' ? 'text-qrypt-primary border-b-2 border-qrypt-primary' : 'text-gray-500 hover:text-white'}`}><User className="w-4 h-4"/> Profile Settings</button>
// //       </div>

// //       {/* TAB: PROFILE SETTINGS */}
// //       {activeTab === 'profile' && (
// //           <div className="max-w-2xl bg-gray-900 p-8 rounded-xl border border-gray-700">
// //               <h2 className="text-xl font-bold mb-6 flex items-center gap-2"><Settings className="text-qrypt-primary"/> Edit Information</h2>
// //               <form onSubmit={handleProfileUpdate} className="space-y-4">
// //                   <div>
// //                     <label className="text-sm text-gray-400">Full Name</label>
// //                     <input type="text" className="w-full bg-gray-800 p-3 rounded mt-1 border border-gray-700 outline-none focus:border-qrypt-primary" value={localProfile.name || ''} onChange={(e)=>setLocalProfile({...localProfile, name: e.target.value})} required/>
// //                   </div>
// //                   <div>
// //                     <label className="text-sm text-gray-400">Account Type</label>
// //                     <select className="w-full bg-gray-800 p-3 rounded mt-1 border border-gray-700 outline-none" value={localProfile.account_type || 'single'} onChange={(e)=>setLocalProfile({...localProfile, account_type: e.target.value})}>
// //                         <option value="single">Single User</option>
// //                         <option value="organisation">Organisation</option>
// //                     </select>
// //                   </div>
// //                   {localProfile.account_type === 'organisation' && (
// //                       <>
// //                         <div>
// //                             <label className="text-sm text-gray-400">Org Name</label>
// //                             <input type="text" className="w-full bg-gray-800 p-3 rounded mt-1 border border-gray-700 outline-none" value={localProfile.org_details || ''} onChange={(e)=>setLocalProfile({...localProfile, org_details: e.target.value})} required/>
// //                         </div>
// //                         <div>
// //                             <label className="text-sm text-gray-400">GST Number</label>
// //                             <input type="text" className="w-full bg-gray-800 p-3 rounded mt-1 border border-gray-700 outline-none uppercase" value={localProfile.gst_number || ''} onChange={(e)=>setLocalProfile({...localProfile, gst_number: e.target.value})}/>
// //                         </div>
// //                       </>
// //                   )}
// //                   <button type="submit" className="bg-qrypt-primary w-full py-3 rounded font-bold hover:bg-blue-600 transition mt-4">Save Changes</button>
// //               </form>
// //               <div className="mt-12 pt-6 border-t border-red-900/50">
// //                   <h3 className="text-red-500 font-bold mb-2">Danger Zone</h3>
// //                   <button onClick={handleAccountDelete} className="bg-red-600/20 text-red-500 hover:bg-red-600 hover:text-white border border-red-600 px-6 py-2 rounded font-bold transition">Delete Account Permanently</button>
// //               </div>
// //           </div>
// //       )}

// //       {/* TAB: VPN ACCESS */}
// //       {activeTab === 'vpn' && (
// //         <>
// //           {!license ? (
// //             <div className="bg-qrypt-card p-10 rounded-xl text-center border border-gray-700">
// //               <h2 className="text-2xl font-bold mb-4">No Active License Found</h2>
// //               <button onClick={() => navigate('/pricing')} className="px-6 py-3 bg-qrypt-primary rounded-lg font-bold">Buy a License</button>
// //             </div>
// //           ) : (
// //             <>
// //               {/* --- NEW: DOWNLOAD CLIENT SECTION --- */}
// //               <div className="bg-gradient-to-r from-gray-900 to-qrypt-primary/20 p-6 rounded-xl border border-qrypt-primary/50 shadow-lg mb-8 flex flex-col md:flex-row justify-between items-center gap-6">
// //                   <div>
// //                       <h3 className="text-xl font-bold text-white mb-2 flex items-center gap-2"><Download className="w-5 h-5 text-qrypt-primary"/> Download QryptShield Client</h3>
// //                       <p className="text-gray-400 text-sm mb-3">Install the quantum-safe desktop application to connect to the VPN network.</p>
// //                       <div className="flex items-start gap-2 bg-gray-800/80 p-3 rounded border border-gray-700 text-xs text-gray-300">
// //                           <Info className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5"/>
// //                           <p>To log in to the application, use your registered email (<strong className="text-white">{profile?.email}</strong>) and your License Key below.</p>
// //                       </div>
// //                   </div>
// //                   {/* Pointing to the tar.gz file served by Nginx */}
// //                   <a href="/qryptvpn_client_installer.tar.gz" download className="bg-qrypt-primary hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-lg flex items-center gap-2 transition whitespace-nowrap shadow-lg shadow-blue-900/50">
// //                       <Download className="w-5 h-5"/> Download for Linux
// //                   </a>
// //               </div>

// //               <div className="grid lg:grid-cols-3 gap-8">
// //                 <div className="lg:col-span-1 space-y-6">
// //                   {status?.needs_renewal && (
// //                       <div className="bg-yellow-500/20 border border-yellow-500 p-4 rounded-xl flex flex-col gap-3 animate-pulse">
// //                           <div className="flex items-center gap-2 text-yellow-500 font-bold"><AlertTriangle/> Expires Soon!</div>
// //                           <p className="text-sm">Expires in {status.days_left} days.</p>
// //                           <button onClick={() => navigate('/pricing')} className="bg-yellow-500 text-black font-bold py-2 rounded hover:bg-yellow-400">Renew Now</button>
// //                       </div>
// //                   )}
// //                   <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-xl">
// //                     <h3 className="text-gray-400 text-sm font-bold mb-4">License Details</h3>
// //                     <div className="bg-black/30 p-3 rounded-lg flex items-center gap-3 border border-gray-600 mb-4 cursor-text select-all">
// //                       <Key className="text-yellow-500 w-5 h-5" />
// //                       <code className="text-qrypt-primary font-mono text-sm break-all">{license.license_key}</code>
// //                     </div>
// //                     <div className="space-y-3 text-sm">
// //                       <div className="flex justify-between border-b border-gray-700 pb-2"><span className="text-gray-400">Capacity</span><span className="font-bold">{license.max_users} Users</span></div>
// //                       <div className="flex justify-between border-b border-gray-700 pb-2"><span className="text-gray-400">Duration</span><span className="font-bold">{calcMonths(license.start_date, license.expiry_date)} Mo</span></div>
// //                       <div className="flex justify-between border-b border-gray-700 pb-2"><span className="text-gray-400">Expiry</span><span>{new Date(license.expiry_date).toLocaleDateString()}</span></div>
// //                       <div className="flex justify-between pt-2"><span className="text-gray-400">Status</span><span className={`capitalize font-bold ${license.status === 'active' ? 'text-green-500' : 'text-red-500'}`}>{license.status}</span></div>
// //                     </div>
// //                   </div>
// //                 </div>
// //                 <div className="lg:col-span-2">
// //                   <div className="bg-qrypt-card p-6 rounded-xl border border-gray-700">
// //                     <div className="flex justify-between items-center mb-6">
// //                       <h3 className="text-xl font-bold flex items-center gap-2"><Users className="text-qrypt-primary"/> Authorized Employees ({license.valid_emails?.length || 0}/{license.max_users})</h3>
// //                     </div>
// //                     <form onSubmit={handleAddEmployee} className="flex gap-3 mb-8">
// //                       <input type="email" placeholder="colleague@company.com" className="flex-1 bg-gray-900 border border-gray-600 rounded px-4 outline-none focus:border-qrypt-primary" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} />
// //                       <button type="submit" disabled={license.valid_emails?.length >= license.max_users} className="bg-qrypt-primary px-6 py-2 rounded font-bold disabled:bg-gray-600 flex items-center gap-2">
// //                           <UserPlus className="w-5 h-5"/> Add
// //                       </button>
// //                     </form>
// //                     <table className="w-full text-left bg-gray-800 rounded overflow-hidden">
// //                       <tbody className="divide-y divide-gray-700">
// //                           {license.valid_emails?.map((email) => {
// //                               const isOwner = email === license.purchaser_email;
// //                               return (
// //                                 <tr key={email} className="hover:bg-gray-700 transition">
// //                                   <td className="p-4 font-medium flex items-center gap-2">
// //                                     {email}
// //                                     {isOwner && (
// //                                         <span className="text-xs bg-qrypt-primary text-white px-2 py-0.5 rounded-full font-bold">
// //                                             Owner
// //                                         </span>
// //                                     )}
// //                                   </td>
// //                                   <td className="p-4 text-right">
// //                                     {!isOwner && (
// //                                       <div className="flex justify-end gap-3">
// //                                         <button onClick={() => handleEditEmployee(email)} className="text-blue-400 hover:text-blue-300 p-2"><Edit2 className="w-4 h-4"/></button>
// //                                         <button onClick={() => handleRemoveEmployee(email)} className="text-red-400 hover:text-red-300 p-2"><Trash2 className="w-4 h-4"/></button>
// //                                       </div>
// //                                     )}
// //                                   </td>
// //                                 </tr>
// //                               );
// //                           })}
// //                       </tbody>
// //                     </table>
// //                   </div>
// //                 </div>
// //               </div>
// //             </>
// //           )}
// //         </>
// //       )}
// //     </div>
// //   );
// // };

// // export default Dashboard;

// // change code 25/02/2026

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/slices/authSlice";
import {
  fetchDashboardRequest,
  updateProfileRequest,
  deleteProfileRequest,
  addEmployeeRequest,
  editEmployeeRequest,
  removeEmployeeRequest,
} from "../redux/slices/userSlice";
import SEO from "../components/SEO";
import {
  Key,
  User,
  LogOut,
  Download,
  Info,
  AlertTriangle,
  Users,
  UserPlus,
  Edit2,
  Trash2,
  Settings,
} from "lucide-react";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { profile, license, status, loading, error } = useSelector(
    (state) => state.user,
  );
  const { token } = useSelector((state) => state.auth);

  const [activeTab, setActiveTab] = useState("vpn");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [localProfile, setLocalProfile] = useState(profile);

  useEffect(() => {
    setLocalProfile(profile);
  }, [profile]);

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    dispatch(fetchDashboardRequest());
  }, [token, dispatch, navigate]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleProfileUpdate = (e) => {
    e.preventDefault();
    dispatch(updateProfileRequest(localProfile));
  };

  const handleAccountDelete = () => {
    if (window.confirm("Delete your account permanently?")) {
      dispatch(deleteProfileRequest());
    }
  };

  const handleAddEmployee = (e) => {
    e.preventDefault();
    if (!license) return;
    if (!newEmail.trim()) return alert("Enter an email");
    dispatch(
      addEmployeeRequest({
        employee_email: newEmail.trim(),
        license_key: license.license_key,
      }),
    );
    setNewEmail("");
  };

  const handleEditEmployee = (email) => {
    if (!license) return;
    const updated = window.prompt("Update email", email);
    if (!updated || updated === email) return;
    dispatch(
      editEmployeeRequest({
        old_email: email,
        new_email: updated.trim(),
        license_key: license.license_key,
      }),
    );
  };

  const handleRemoveEmployee = (email) => {
    if (!license) return;
    if (!window.confirm("Remove this user?")) return;
    dispatch(
      removeEmployeeRequest({
        employee_email: email,
        license_key: license.license_key,
      }),
    );
  };

  const calcMonths = (start, end) => {
    if (!start || !end) return 0;
    const d1 = new Date(start);
    const d2 = new Date(end);
    return Math.max(
      1,
      (d2.getFullYear() - d1.getFullYear()) * 12 -
        d1.getMonth() +
        d2.getMonth(),
    );
  };

  if (loading && !profile?.name) {
    return (
      <div className="min-h-screen bg-[#0B0F19] flex flex-col items-center justify-center text-white gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" />
        <p className="text-sm text-gray-300">Loading dashboard…</p>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen bg-[#0B0F19] text-white font-sans">
      <SEO title="Dashboard - QryptShield" />

      <div className="fixed inset-0 z-0 pointer-events-none">
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage: `linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[100px]" />
      </div>

      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className="relative z-10 flex min-h-screen">
        <aside
          className={`fixed inset-y-0 left-0 z-30 w-72 bg-black/70 backdrop-blur-xl border-r border-white/10 transform transition-transform duration-300 flex flex-col md:sticky md:top-0 md:h-screen md:translate-x-0 md:z-auto ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
        >
          <div className="flex items-center justify-between px-5 py-4 border-b border-white/5">
            <div className="flex items-center gap-2">
              <img src="logo.png" alt="logo" className="h-8 w-auto" />
              <div>
                <p className="font-bold text-white">QryptShield</p>
                <p className="text-sm text-gray-400">User Portal</p>
              </div>
            </div>
            <button
              className="md:hidden text-gray-400 hover:text-white"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close menu"
            >
              ✕
            </button>
          </div>

          <nav className="px-4 py-5 space-y-2 flex-1 overflow-y-auto">
            {[
              { key: "vpn", label: "Secure Tunnel", icon: Key },
              { key: "profile", label: "Profile & Identity", icon: User },
            ].map((item) => {
              const Icon = item.icon;
              const active = activeTab === item.key;
              return (
                <button
                  key={item.key}
                  onClick={() => {
                    setActiveTab(item.key);
                    setSidebarOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-semibold border transition ${active ? "bg-blue-600 text-white border-blue-500" : "bg-white/5 text-gray-300 border-white/10 hover:bg-white/10"}`}
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                </button>
              );
            })}

            <div className="mt-6 space-y-3 rounded-2xl bg-white/5 border border-white/10 p-4">
              <div className="flex items-center justify-between">
                <span className="text-xs text-gray-400 uppercase tracking-wider">
                  License
                </span>
                <span className="text-[11px] px-2 py-1 rounded-full border border-white/10 bg-white/5">
                  {license ? license.status : "No plan"}
                </span>
              </div>
              <p className="text-sm text-white font-semibold">
                {license
                  ? `${license.valid_emails?.length || 0}/${license.max_users} seats`
                  : "Activate your plan"}
              </p>
              {status?.needs_renewal && (
                <p className="text-xs text-yellow-300">
                  Expires in {status.days_left} days
                </p>
              )}
              {!license && (
                <button
                  onClick={() => navigate("/pricing")}
                  className="w-full mt-2 bg-blue-600 hover:bg-blue-500 text-white font-semibold py-2 rounded-lg"
                >
                  Buy a plan
                </button>
              )}
            </div>
          </nav>
        </aside>

        <div className="flex-1 min-w-0 min-h-screen">
          <header className="sticky top-0 z-20 bg-[#0B0F19]/80 backdrop-blur-xl border-b border-white/10 px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <button
                className="md:hidden px-3 py-2 rounded-lg border border-white/10 text-gray-200"
                onClick={() => setSidebarOpen(!sidebarOpen)}
                aria-label="Toggle menu"
              >
                ☰
              </button>
              <div>
                <p className="text-sm text-gray-400">Welcome back</p>
                <p className="font-semibold text-white">
                  {profile?.name || profile?.email}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="px-3 py-1 rounded-full text-xs bg-white/5 border border-white/10 text-gray-300">
                {profile?.account_type === "organisation"
                  ? "Organization"
                  : "Individual"}
              </span>
              <button
                onClick={handleLogout}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 transition"
              >
                <LogOut className="w-4 h-4" />
                Logout
              </button>
            </div>
          </header>

          <main className="px-4 sm:px-6 lg:px-8 pt-6 pb-16 space-y-10">
            {error && (
              <div className="bg-red-500/10 border border-red-500/30 text-red-200 text-sm p-4 rounded-xl">
                {typeof error === "string"
                  ? error
                  : "Failed to load dashboard data."}
              </div>
            )}

            {activeTab === "vpn" && (
              <>
                {!license ? (
                  <div className="bg-white/5 border border-white/10 p-10 rounded-2xl text-center shadow-xl">
                    <h2 className="text-2xl font-bold mb-4">
                      No Active License
                    </h2>
                    <p className="text-gray-400 mb-6">
                      Purchase a license to activate your quantum-safe VPN
                      tunnel.
                    </p>
                    <button
                      onClick={() => navigate("/pricing")}
                      className="px-6 py-3 bg-blue-600 hover:bg-blue-500 rounded-lg font-bold"
                    >
                      View Pricing
                    </button>
                  </div>
                ) : (
                  <div className="space-y-8">
                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                      <div className="bg-white/5 border border-white/10 rounded-xl p-4">
                        <p className="text-sm text-gray-400">Plan Status</p>
                        <div className="flex items-center justify-between mt-2">
                          <span
                            className={`text-lg font-semibold capitalize ${license.status === "active" ? "text-green-400" : "text-red-400"}`}
                          >
                            {license.status}
                          </span>
                          {status?.needs_renewal && (
                            <span className="text-xs text-yellow-400 font-semibold">
                              {status.days_left} days left
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="bg-white/5 border border-white/10 rounded-xl p-4">
                        <p className="text-sm text-gray-400">Seats Used</p>
                        <p className="text-lg font-semibold text-white mt-2">
                          {license.valid_emails?.length || 0} /{" "}
                          {license.max_users}
                        </p>
                      </div>
                      <div className="bg-white/5 border border-white/10 rounded-xl p-4">
                        <p className="text-sm text-gray-400">Expires</p>
                        <p className="text-lg font-semibold text-white mt-2">
                          {new Date(license.expiry_date).toLocaleDateString()}
                        </p>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-gray-900 to-blue-900/30 p-6 rounded-2xl border border-blue-500/20 shadow-xl flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
                      <div className="space-y-2 max-w-xl">
                        <h3 className="text-xl font-bold flex items-center gap-2">
                          <Download className="w-5 h-5 text-blue-400" />
                          Download QryptShield Client
                        </h3>
                        <p className="text-gray-300 text-sm">
                          Install the desktop app and log in with your
                          registered email and license key.
                        </p>
                        <div className="flex items-start gap-2 bg-white/5 p-3 rounded border border-white/10 text-xs text-gray-200">
                          <Info className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
                          <p>
                            Email:{" "}
                            <span className="text-white font-semibold">
                              {profile?.email}
                            </span>
                          </p>
                        </div>
                      </div>
                      <a
                        href="/qryptvpn_client_installer.tar.gz"
                        download
                        className="bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 px-6 rounded-lg inline-flex items-center gap-2 transition shadow-lg shadow-blue-900/50"
                      >
                        <Download className="w-5 h-5" />
                        Download for Linux
                      </a>
                    </div>

                    <div className="grid lg:grid-cols-3 gap-6">
                      <div className="lg:col-span-1 space-y-4">
                        {status?.needs_renewal && (
                          <div className="bg-yellow-500/15 border border-yellow-500/40 p-4 rounded-xl flex flex-col gap-3">
                            <div className="flex items-center gap-2 text-yellow-300 font-bold">
                              <AlertTriangle className="w-4 h-4" />
                              Renewal Alert
                            </div>
                            <p className="text-sm text-yellow-100">
                              Expires in {status.days_left} days.
                            </p>
                            <button
                              onClick={() => navigate("/pricing")}
                              className="bg-yellow-400 text-black font-bold py-2 rounded hover:bg-yellow-300"
                            >
                              Renew Now
                            </button>
                          </div>
                        )}

                        <div className="bg-white/5 border border-white/10 p-6 rounded-2xl shadow-lg">
                          <h3 className="text-sm font-bold text-gray-300 mb-4 uppercase tracking-wider">
                            License Details
                          </h3>
                          <div className="bg-black/30 p-3 rounded-lg flex items-center gap-3 border border-white/10 mb-4 cursor-text select-all">
                            <Key className="text-yellow-400 w-5 h-5" />
                            <code className="text-blue-300 font-mono text-sm break-all">
                              {license.license_key}
                            </code>
                          </div>
                          <div className="space-y-3 text-sm">
                            <div className="flex justify-between border-b border-white/5 pb-2">
                              <span className="text-gray-400">Capacity</span>
                              <span className="font-semibold">
                                {license.max_users} users
                              </span>
                            </div>
                            <div className="flex justify-between border-b border-white/5 pb-2">
                              <span className="text-gray-400">Duration</span>
                              <span className="font-semibold">
                                {calcMonths(
                                  license.start_date,
                                  license.expiry_date,
                                )}{" "}
                                months
                              </span>
                            </div>
                            <div className="flex justify-between border-b border-white/5 pb-2">
                              <span className="text-gray-400">Expiry</span>
                              <span>
                                {new Date(
                                  license.expiry_date,
                                ).toLocaleDateString()}
                              </span>
                            </div>
                            <div className="flex justify-between pt-2">
                              <span className="text-gray-400">Status</span>
                              <span
                                className={`capitalize font-bold ${license.status === "active" ? "text-green-400" : "text-red-400"}`}
                              >
                                {license.status}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="lg:col-span-2">
                        <div className="bg-white/5 border border-white/10 p-6 rounded-2xl shadow-lg">
                          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                            <h3 className="text-xl font-bold flex items-center gap-2">
                              <Users className="text-blue-400" /> Authorized
                              Employees
                            </h3>
                            <form
                              onSubmit={handleAddEmployee}
                              className="flex w-full sm:w-auto gap-3"
                            >
                              <input
                                type="email"
                                placeholder="colleague@company.com"
                                className="flex-1 bg-gray-900 border border-white/10 rounded px-3 py-2 text-sm outline-none focus:border-blue-400"
                                value={newEmail}
                                onChange={(e) => setNewEmail(e.target.value)}
                              />
                              <button
                                type="submit"
                                disabled={
                                  license.valid_emails?.length >=
                                  license.max_users
                                }
                                className="bg-blue-600 hover:bg-blue-500 px-4 py-2 rounded font-semibold disabled:bg-gray-600 flex items-center gap-2"
                              >
                                <UserPlus className="w-4 h-4" /> Add
                              </button>
                            </form>
                          </div>

                          <div className="overflow-auto -mx-4 sm:mx-0">
                            <table className="w-full text-left text-sm min-w-[500px]">
                              <tbody className="divide-y divide-white/10">
                                {license.valid_emails?.map((email) => {
                                  const isOwner =
                                    email === license.purchaser_email;
                                  return (
                                    <tr
                                      key={email}
                                      className="hover:bg-white/5 transition"
                                    >
                                      <td className="p-4 font-medium flex items-center gap-2">
                                        {email}
                                        {isOwner && (
                                          <span className="text-xs bg-blue-600 text-white px-2 py-0.5 rounded-full font-bold">
                                            Owner
                                          </span>
                                        )}
                                      </td>
                                      <td className="p-4 text-right">
                                        {!isOwner && (
                                          <div className="flex justify-end gap-3">
                                            <button
                                              onClick={() =>
                                                handleEditEmployee(email)
                                              }
                                              className="text-blue-300 hover:text-blue-200 p-2"
                                            >
                                              <Edit2 className="w-4 h-4" />
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleRemoveEmployee(email)
                                              }
                                              className="text-red-300 hover:text-red-200 p-2"
                                            >
                                              <Trash2 className="w-4 h-4" />
                                            </button>
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                            {(!license.valid_emails ||
                              license.valid_emails.length === 0) && (
                              <div className="p-6 text-center text-gray-500">
                                No users added yet.
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            {activeTab === "profile" && (
              <div className="grid lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 bg-white/5 border border-white/10 p-8 rounded-2xl shadow-xl">
                  <div className="flex items-center gap-2 mb-6">
                    <div className="p-2 bg-blue-500/10 rounded-xl border border-blue-500/20">
                      <Settings className="text-blue-400" />
                    </div>
                    <div>
                      <h2 className="text-xl font-bold">Profile & Identity</h2>
                      <p className="text-gray-400 text-sm">
                        Update organisation and billing details.
                      </p>
                    </div>
                  </div>

                  <form onSubmit={handleProfileUpdate} className="space-y-4">
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <label className="text-xs text-gray-400 uppercase tracking-wider">
                          Full Name
                        </label>
                        <input
                          type="text"
                          className="w-full bg-gray-900 border border-white/10 rounded-lg p-3 mt-1 outline-none focus:border-blue-400"
                          value={localProfile?.name || ""}
                          onChange={(e) =>
                            setLocalProfile({
                              ...localProfile,
                              name: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div>
                        <label className="text-xs text-gray-400 uppercase tracking-wider">
                          Account Type
                        </label>
                        <select
                          className="w-full bg-gray-900 border border-white/10 rounded-lg p-3 mt-1 outline-none focus:border-blue-400"
                          value={localProfile?.account_type || "single"}
                          onChange={(e) =>
                            setLocalProfile({
                              ...localProfile,
                              account_type: e.target.value,
                            })
                          }
                        >
                          <option value="single">Single User</option>
                          <option value="organisation">Organisation</option>
                        </select>
                      </div>
                    </div>

                    {localProfile?.account_type === "organisation" && (
                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <label className="text-xs text-gray-400 uppercase tracking-wider">
                            Org Name
                          </label>
                          <input
                            type="text"
                            className="w-full bg-gray-900 border border-white/10 rounded-lg p-3 mt-1 outline-none focus:border-blue-400"
                            value={localProfile?.org_details || ""}
                            onChange={(e) =>
                              setLocalProfile({
                                ...localProfile,
                                org_details: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                        <div>
                          <label className="text-xs text-gray-400 uppercase tracking-wider">
                            GST Number
                          </label>
                          <input
                            type="text"
                            className="w-full bg-gray-900 border border-white/10 rounded-lg p-3 mt-1 outline-none focus:border-blue-400 uppercase"
                            value={localProfile?.gst_number || ""}
                            onChange={(e) =>
                              setLocalProfile({
                                ...localProfile,
                                gst_number: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}

                    <div className="flex flex-wrap gap-3 pt-4">
                      <button
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-500 px-6 py-3 rounded-lg font-semibold"
                      >
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={handleLogout}
                        className="px-5 py-3 rounded-lg border border-white/10 text-gray-200 hover:bg-white/5"
                      >
                        Sign Out
                      </button>
                    </div>
                  </form>
                </div>

                <div className="bg-red-500/10 border border-red-500/30 p-6 rounded-2xl h-fit shadow-xl">
                  <div className="flex items-center gap-2 mb-4 text-red-300 font-semibold">
                    <AlertTriangle className="w-4 h-4" /> Danger Zone
                  </div>
                  <p className="text-sm text-red-100/80 mb-4">
                    Deleting your account removes all VPN access and associated
                    licenses.
                  </p>
                  <button
                    onClick={handleAccountDelete}
                    className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-3 rounded-lg transition"
                  >
                    Delete Account Permanently
                  </button>
                </div>
              </div>
            )}
          </main>

          <footer className="px-4 sm:px-6 lg:px-8 pb-6 text-gray-500 text-sm">
            <div className="border-t border-white/10 pt-4 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
              <span>© {new Date().getFullYear()} QryptShield</span>
              <span className="text-gray-400">
                Quantum-secure remote access
              </span>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
